export default __webpack_public_path__ + "static/media/07.e301a708.jpg";